<template>
  <div class="role-desc-dialog">
    <!-- top="385px" -->
    <el-dialog
      :visible.sync="visible"
      title="角色与权限说明"
      :close-on-click-modal="false"
      append-to-body
      width="800"
      @close="closeModal">
        <div class="role-desc-container">
          <div class="role-desc-info">
            上上签提供同业账号多角色区分与权限管理功能。同业可设定子账号角色以精细管理业务与权限。另外，操作员仅能查看自己创建的订单和产生的账单。
          </div>

          <table class="table-box" rules="groups" frame="box">
            <thead>
              <tr>
                <th></th>
                <th class="text-center">管理员</th>
                <th class="text-center">操作员</th>
                <th class="text-center">财务</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in dataList" :key="index">
                <td>{{item.content}}</td>
                <td class="text-center">
                  <span v-if="item.roleList.includes('admin')" class="success"></span>
                  <span v-else class="error"></span>
                </td>
                <td class="text-center">
                  <span v-if="item.onlyOneself && item.onlyOneself.includes('operator')" class="text">{{ item.onlyOneselfText }}</span>
                  <span v-else-if="item.roleList.includes('operator')" class="success"></span>
                  <span v-else class="error"></span>
                </td>
                <td class="text-center">
                  <span v-if="item.onlyOneself && item.onlyOneself.includes('finance')" class="text">{{ item.onlyOneselfText }}</span>
                  <span v-else-if="item.roleList.includes('finance')" class="success"></span>
                  <span v-else class="error"></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'role-desc-dialog',
  props: {
    show: {
      type: Boolean,
      required: true,
      default: true,
    },
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val);
      },
    },
  },
  data() {
    return {
      dataList: [
        {
          content: '查看/编辑/支付订单',
          roleList: ['admin', 'finance'],
          onlyOneself: ['operator'],
          onlyOneselfText: '仅可查看/操作自己的订单',
        },
        {
          content: '下单（签证商品/保险）',
          roleList: ['admin', 'operator'],
        },
        {
          content: '分享给顾客下单',
          roleList: ['admin', 'operator'],
        },
        {
          content: '店铺设置',
          roleList: ['admin'],
        },
        {
          content: '店铺分享',
          roleList: ['admin', 'operator'],
        },
        {
          content: '查看/下载账单',
          roleList: ['admin', 'finance'],
          onlyOneself: ['operator'],
          onlyOneselfText: '仅可查看/下载自己的账单',
        },
        {
          content: '成员管理',
          roleList: ['admin'],
        },
        {
          content: '查看同业汇款记录',
          roleList: ['admin', 'finance'],
          onlyOneself: ['operator'],
          onlyOneselfText: '仅可查看自己的汇款记录',
        },
      ],
    };
  },
  watch: {

  },
  methods: {
    // 关闭对话框回调
    closeModal() {
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog--small {
  width: 800px;
}

/deep/ .el-dialog__header {
  padding: 18px 20px 19px 20px;
  text-align: center;
}

/deep/ .el-dialog {
  left: 50%;
  top: 50%!important;
  transform: translate(-50%, -50%);
}

/deep/ .el-dialog__body {
  border-top: 1px solid #E9EEF2;
  padding: 0;
}

.role-desc-container {
  padding: 24px;
  .role-desc-info {
    font-size: 16px;
    color: #2F333D;
    line-height: 24px;
    margin-bottom: 24px ;
  }
}

.table-box{
  margin-top: 24px;
  width: 100%;
  font-size: 14px;
  border: none;
  color: #2F333D;
  thead{
    border:1px solid #E9EEF2;
    th{
      background-color: #FAFBFC;
      padding: 0 16px;
      text-align: left;
      font-weight: 600;
      height: 60px;
    }
  }
  tbody{
    tr{
      border-bottom: 1px solid #E9EEF2;
      td{
        padding: 14px 40px 14px 40px;
        background-color: #fff;
        font-size: 14px;
        color: #2F333D;
        line-height: 14px;
        height: 52px;
        .error {
          display: inline-block;
          &::after {
            content: "";
            display: block;
            width: 20px;
            height: 20px;
            background: url(../../../../assets/imgs/user/role-error.png) no-repeat;
            background-size: 100% 100%;
          }
        }
        .success {
          display: inline-block;
          &::after {
            content: "";
            display: block;
            width: 20px;
            height: 20px;
            background: url(../../../../assets/imgs/user/role-success.png) no-repeat;
            background-size: 100% 100%;
          }
        }
      }
    }
  }
  .text-center{
    text-align: center;
    position: relative;
    .name {
      position: relative;
      padding: 0;
      display: inline-block;
      .is-admin {
        position: absolute;
        display: inline-block;
        padding: 4px 8px;
        background: rgba(58, 165, 255, .08);
        color: #599FFF;
        border-radius: 2px;
        font-size: 12px;
        line-height: 12px;
        margin-left: 12px;
        white-space: nowrap;
        top: 50%;
        transform: translateY(-50%);
        z-index: 2;
      } 
    }
    
  }
  .color-red{
    color: #F4455C;
  }
  .btn{
    display: inline-block;
    color: #599FFF;
    font-size: 14px;
    cursor: pointer;
    &+.btn{
      margin-left: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/user-children/components/role-desc-dialog.vue